"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let FieldsetRegisterEntry = class FieldsetRegisterEntry extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    onReferenceEntrySelected(...args) {
        const [option] = args;
        if (this.item.id == null && option.invoice_type === 'proforma') {
            this.item.invoice.amount = option.amount;
            this.item.invoice.fulfillment_date = option.fulfillment_date;
            this.item.invoice.due_date = option.due_date;
            this.item.partner_id = option.client_id;
        }
    }
    onReferenceNumberChanged(...args) {
        const [referenceNumber] = args;
        if (!referenceNumber || !referenceNumber.trim().length) {
            return;
        }
        const item = this.item;
        if (item.document_type == 'invoice' && item.isNew && (!item.invoice || !item.invoice.id)) {
            this.checkInvoiceExists(referenceNumber.trim());
        }
    }
    checkInvoiceExists(...args) {
        const [invoiceNumber] = args;
        this.$fn
            .fetch('check', {
            parameters: {
                kind: 'invoice',
                op: 'exists',
                query: invoiceNumber,
                company_id: this.item.version.company_id,
                partner_id: _.get(this.item.partner, 'id'),
            }
        })
            .then(resp => {
            if (resp.passed) {
                this.invoiceCheckResult = resp.data;
                return;
            }
            this.invoiceCheckResult = null;
        });
    }
    assignInvoiceCheckResult(...args) {
        if (!this.invoiceCheckResult) {
            return;
        }
        const item = this.item;
        item.invoice = this.invoiceCheckResult;
        if (!item.partner || !item.partner.id) {
            item.partner = this.invoiceCheckResult.partner || this.invoiceCheckResult.client;
        }
        this.invoiceCheckResult = null;
    }
    item;
    onItem(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("item");
    }
    labelAlign;
    onLabel_align(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("labelAlign");
    }
    form;
    onForm(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("form");
    }
    isSaving;
    onIs_saving(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("isSaving");
    }
    priorities;
    documentTypes;
    async $$load_documentTypes() {
        return this.$fn.getEnumValuesFromSchema('RegisterDocumentType');
    }
    directions;
    async $$load_directions() {
        return this.$fn.getEnumValuesFromSchema('RegisterEntryDirection');
    }
    invoiceTypes;
    async $$load_invoiceTypes() {
        return this.$fn.getEnumValuesFromSchema('InvoiceType');
    }
    paymentMethods;
    async $$load_paymentMethods() {
        return this.$fn.fetch('list_payment_method')
            .then(data => _.map(data, p => ({
            value: p.id,
            text: this.$fn.pgettext('PaymentMethod', p.name)
        })));
    }
    tags;
    async $$load_tags() {
        return this.$fn.fetch('get_tags', { parameters: { tag_type: 'register-entry:*' } });
    }
    categories;
    async $$load_categories() {
        return _.get(this.$data.tags, 'register-entry:category', []);
    }
    statuses;
    async $$load_statuses() {
        return _.get(this.$data.tags, 'register-entry:status', []);
    }
    clerks;
    async $$load_clerks() {
        return _.get(this.$data.tags, 'register-entry:clerk', []);
    }
    deliveryModes;
    async $$load_deliveryModes() {
        return _.get(this.$data.tags, 'register-entry:delivery-mode', []);
    }
    currencies;
    invoiceCheckResult;
    ux;
    b_8680084583475136_dataSource;
    async $$load_b_8680084583475136_dataSource() {
        return {
            name: "suggest_register_entry",
            parameters: {
                register_id: this.item.version.register_id,
                source: this.item.id,
            },
        };
    }
    dataMembers = ['priorities', 'documentTypes', 'directions', 'invoiceTypes', 'paymentMethods', 'tags', 'categories', 'statuses', 'clerks', 'deliveryModes', 'currencies', 'invoiceCheckResult', 'ux', 'b_8680084583475136_dataSource'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                priorities: {
                    0: this.$fn.pgettext("Priority", "normal"),
                    1: this.$fn.pgettext("Priority", "important"),
                    2: this.$fn.pgettext("Priority", "urgent"),
                },
                documentTypes: null,
                directions: null,
                invoiceTypes: null,
                paymentMethods: null,
                tags: null,
                categories: null,
                statuses: null,
                clerks: null,
                deliveryModes: null,
                currencies: ["HUF",
                    "EUR",
                    "USD",
                ],
                invoiceCheckResult: null,
                ux: null,
                b_8680084583475136_dataSource: null,
            },
        };
    }
    get invoiceRegister() {
        if (this.loaded) {
            return this.item.document_type === 'invoice';
        }
        return null;
    }
    get contractRegister() {
        if (this.loaded) {
            return this.item.document_type === 'contract';
        }
        return null;
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_1468474219929533_emit_7946_getActionArgs($event) {
        return {
            event: "documentTypeChanged",
        };
    }
    async evh_1468474219929533_input(event, scope) {
        return await this.actions.evh_1468474219929533_input.executeFromDOM(this, event, scope);
    }
    async act_6917646200545441_script_7948_getActionArgs_value($event) {
        this.onReferenceNumberChanged($event.originalEvent);
    }
    async act_6917646200545441_script_7948_getActionArgs($event) {
        return {
            value: () => this.act_6917646200545441_script_7948_getActionArgs_value($event),
        };
    }
    async evh_6917646200545441_input(event, scope) {
        return await this.actions.evh_6917646200545441_input.executeFromDOM(this, event, scope);
    }
    async act_6941071772471093_script_7950_getActionArgs_value($event) {
        this.assignInvoiceCheckResult();
    }
    async act_6941071772471093_script_7950_getActionArgs($event) {
        return {
            value: () => this.act_6941071772471093_script_7950_getActionArgs_value($event),
        };
    }
    async evh_6941071772471093_clickPreventStop(event, scope) {
        return await this.actions.evh_6941071772471093_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_7463771596263925_emit_7952_getActionArgs($event) {
        return {
            event: "close",
        };
    }
    async act_7463771596263925_showModal_7954_getActionArgs($event) {
        return {
            name: "CreateInvoice",
            props: {
                registerEntry: this.item.id,
            },
        };
    }
    async evh_7463771596263925_clickPreventStop(event, scope) {
        return await this.actions.evh_7463771596263925_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_8680084583475136_script_7956_getActionArgs_value($event) {
        this.onReferenceEntrySelected($event.data.option);
    }
    async act_8680084583475136_script_7956_getActionArgs($event) {
        return {
            value: () => this.act_8680084583475136_script_7956_getActionArgs_value($event),
        };
    }
    async evh_8680084583475136_optionSelected(event, scope) {
        return await this.actions.evh_8680084583475136_optionSelected.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_7944 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_7943 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_7944,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_7943],
        });
        const act_1468474219929533_emit_7946 = new core_1.actions.EmitAction({
            actionArgs: this.act_1468474219929533_emit_7946_getActionArgs,
            events: [],
        });
        const evh_1468474219929533_input_7945 = new core_1.actions.EventHandlerImpl({
            action: act_1468474219929533_emit_7946,
            event: "input",
            displayName: "emit",
        });
        const evh_1468474219929533_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1468474219929533_input_7945],
        });
        const act_6917646200545441_script_7948 = new core_1.actions.ScriptAction({
            actionArgs: this.act_6917646200545441_script_7948_getActionArgs,
            events: [],
        });
        const evh_6917646200545441_input_7947 = new core_1.actions.EventHandlerImpl({
            action: act_6917646200545441_script_7948,
            event: "input",
            displayName: "script",
        });
        const evh_6917646200545441_input = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6917646200545441_input_7947],
        });
        const act_6941071772471093_script_7950 = new core_1.actions.ScriptAction({
            actionArgs: this.act_6941071772471093_script_7950_getActionArgs,
            events: [],
        });
        const evh_6941071772471093_clickPreventStop_7949 = new core_1.actions.EventHandlerImpl({
            action: act_6941071772471093_script_7950,
            event: "click.prevent.stop",
            displayName: "script",
        });
        const evh_6941071772471093_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6941071772471093_clickPreventStop_7949],
        });
        const act_7463771596263925_emit_7952 = new core_1.actions.EmitAction({
            actionArgs: this.act_7463771596263925_emit_7952_getActionArgs,
            events: [],
        });
        const evh_7463771596263925_clickPreventStop_7951 = new core_1.actions.EventHandlerImpl({
            action: act_7463771596263925_emit_7952,
            event: "click.prevent.stop",
            displayName: "emit",
        });
        const act_7463771596263925_showModal_7954 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_7463771596263925_showModal_7954_getActionArgs,
            events: [],
        });
        const evh_7463771596263925_clickPreventStop_7953 = new core_1.actions.EventHandlerImpl({
            action: act_7463771596263925_showModal_7954,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_7463771596263925_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7463771596263925_clickPreventStop_7951, evh_7463771596263925_clickPreventStop_7953],
        });
        const act_8680084583475136_script_7956 = new core_1.actions.ScriptAction({
            actionArgs: this.act_8680084583475136_script_7956_getActionArgs,
            events: [],
        });
        const evh_8680084583475136_optionSelected_7955 = new core_1.actions.EventHandlerImpl({
            action: act_8680084583475136_script_7956,
            event: "optionSelected",
            displayName: "script",
        });
        const evh_8680084583475136_optionSelected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8680084583475136_optionSelected_7955],
        });
        return {
            act_7315092382398562_reloadComponentData_7944,
            evh_7315092382398562_reload_7943,
            evh_7315092382398562_reload,
            act_1468474219929533_emit_7946,
            evh_1468474219929533_input_7945,
            evh_1468474219929533_input,
            act_6917646200545441_script_7948,
            evh_6917646200545441_input_7947,
            evh_6917646200545441_input,
            act_6941071772471093_script_7950,
            evh_6941071772471093_clickPreventStop_7949,
            evh_6941071772471093_clickPreventStop,
            act_7463771596263925_emit_7952,
            evh_7463771596263925_clickPreventStop_7951,
            act_7463771596263925_showModal_7954,
            evh_7463771596263925_clickPreventStop_7953,
            evh_7463771596263925_clickPreventStop,
            act_8680084583475136_script_7956,
            evh_8680084583475136_optionSelected_7955,
            evh_8680084583475136_optionSelected,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], FieldsetRegisterEntry.prototype, "item", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('item'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FieldsetRegisterEntry.prototype, "onItem", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "right",
    }),
    __metadata("design:type", String)
], FieldsetRegisterEntry.prototype, "labelAlign", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('labelAlign'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FieldsetRegisterEntry.prototype, "onLabel_align", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], FieldsetRegisterEntry.prototype, "form", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('form'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FieldsetRegisterEntry.prototype, "onForm", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], FieldsetRegisterEntry.prototype, "isSaving", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('isSaving'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FieldsetRegisterEntry.prototype, "onIs_saving", null);
FieldsetRegisterEntry = __decorate([
    (0, vue_property_decorator_1.Component)()
], FieldsetRegisterEntry);
exports.default = FieldsetRegisterEntry;
vue_property_decorator_1.Vue.component("FieldsetRegisterEntry", FieldsetRegisterEntry);
